import React from 'react';
import ProfessionalsEmployeeDetails from '../../../components/professionals/ProfessionalsEmployeeDetails';
import '../../../components/professionals/ProfessionalsEmployeeDetails.scss';
import { useAgencyProfessionalQuery } from '../../../redux/external-agency';

const AgencyProfessionalsEmployeeDetails = ({ caregiverId, setShowEditIcon }) => {
	const { data: professional, isFetching } = useAgencyProfessionalQuery(caregiverId, {
		refetchOnMountOrArgChange: true
	});

	return (
		<ProfessionalsEmployeeDetails
			professional={professional}
			isFetching={isFetching}
			setShowEditIcon={setShowEditIcon}
		/>
	);
};

export default AgencyProfessionalsEmployeeDetails;
